export default __webpack_public_path__ + "static/media/tal.ab263383.txt";